import SurveysPage from './Page'

export default SurveysPage
